import { combineReducers } from 'redux'
import data from './data'
import modals from './modals'

export default combineReducers({
  data,
  modals,
})
